"use strict";

var versionInfo = process.env.FRONTENDGUI_VERSION;
var versionTag = document.createElement('meta');
versionTag.name = 'frontendgui-version';
versionTag.content = versionInfo;
window.document.head.insertAdjacentElement('afterbegin', versionTag);
window.frontendguiVersion = versionInfo;